import {Component, Input, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import { HttpClient } from '@angular/common/http';
import {Slavnost} from '../model/slavnost';
import {TranslateService} from '@ngx-translate/core';
import {AisDatePipe} from 'ais-common';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'app-slavnost',
    templateUrl: './slavnost.component.html',
    styleUrls: ['./slavnost.component.css'],
    standalone: false
})
export class SlavnostComponent implements OnInit {

  @Input()
  slavnost: Slavnost;

  constructor(
    private appService: AppService,
    private http: HttpClient,
    private translate: TranslateService
  ) { }

  ngOnInit() {
  }

  odhlasitZoSlavnosti() {
    this.appService.openConfirmDialog(this.translate.instant('Odhlásiť zo slávnosti?'))
      .subscribe(res => {
        if (res === 'OK') {
          this.http.get(
            '/ais/rest/portal/slavnosti/odhlasit',
            {
              params: {id: this.slavnost.id.toString()}
            }).subscribe(
            out => {
              this.appService.openOkDialog(this.translate.instant('Odhlásenie prebehlo úspešne.'));
              this.appService.fetchStudia(true);
            },
            (err) => {
              this.appService.openErrorDialog(err.error.message);
            }
          );
        }
      });
  }

  potvrditUcast() {
    this.appService.openConfirmDialog(this.translate.instant('Potvrdiť účasť?'))
      .subscribe(res => {
        if (res === 'OK') {
          this.http.get(
            '/ais/rest/portal/slavnosti/potvrdit',
            {
              params: {id: this.slavnost.id.toString()}
            }).subscribe(
            out => {
              this.appService.openOkDialog(this.translate.instant('Účasť potvrdená.'));
              this.appService.fetchStudia(true);
            },
            (err) => {
              this.appService.openErrorDialog(err.error.message);
            }
          );
        }
      });
  }

  odmietnutUcast() {
    this.appService.openConfirmDialog(this.translate.instant('Odmietnuť účasť?'))
      .subscribe(res => {
        if (res === 'OK') {
          this.http.get(
            '/ais/rest/portal/slavnosti/odmietnut',
            {
              params: {id: this.slavnost.id.toString()}
            }).subscribe(
            out => {
              this.appService.openOkDialog(this.translate.instant('Účasť odmietnutá.'));
              this.appService.fetchStudia(true);
            },
            (err) => {
              this.appService.openErrorDialog(err.error.message);
            }
          );
        }
      });
  }

  getDatum(slavnost: Slavnost) {
    if (slavnost.datumOd && slavnost.datumDo && slavnost.datumOd === slavnost.datumDo) {
      return (new DatePipe('sk_SK')).transform(slavnost.datumOd);
    }

    let out = '';

    if (slavnost.datumOd) {
      out += (new DatePipe('sk_SK')).transform(slavnost.datumOd);
    }

    if (slavnost.datumDo) {
      out += ' - ' + (new DatePipe('sk_SK')).transform(slavnost.datumDo);
    }

    return out;
  }
}
